import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DailyFeedbackReportsFiltersService {
  public readonly dateStrategies = {
    today: (today: Date) => ({
      start: new Date(today),
      end: new Date(today)
    }),
    yesterday: (today: Date) => ({
      start: this.addDays(today, -1),
      end: this.addDays(today, -1)
    }),
    threeDays: (today: Date) => ({
      start: this.addDays(today, -2),
      end: new Date(today)
    }),
    sevenDays: (today: Date) => ({
      start: this.addDays(today, -6),
      end: new Date(today)
    }),
    currentMonth: (today: Date) => ({
      start: new Date(today.getFullYear(), today.getMonth(), 1),
      end: new Date(today)
    }),
    previousMonth: (today: Date) => ({
      start: new Date(today.getFullYear(), today.getMonth() - 1, 1),
      end: new Date(today.getFullYear(), today.getMonth(), 0)
    }),
    thirtyDays: (today: Date) => ({
      start: this.addDays(today, -29),
      end: new Date(today)
    }),
    ninetyDays: (today: Date) => ({
      start: this.addDays(today, -89),
      end: new Date(today)
    }),
    year: (today: Date) => ({
      start: this.addDays(today, -364),
      end: new Date(today)
    })
  };

  public formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  public getCurrentDate(): Date {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return today;
  }

  private addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
}
